// extracted by mini-css-extract-plugin
export default {"loader":"Content_loader__HQA5L","isLoading":"Content_isLoading__m325U"};